import React, { Component } from "react";
import MarketplaceHeader from '../home/MarketplaceHeader';
import LoginContent from '../home/LoginContent';
import SupportContainer from '../home/SupportContainer';
import MainLoader from '../home/MainLoader';


class LoginPage extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		supportPageName: 'Login',
		supportPageApi: '/login',
		userTypeFaqs: 1,
		showLoader: false
    }
	
}
 
componentDidMount(){

}

updateStateFromChild=(state)=>{
	this.setState(state);
}

  render() {
	 return (
		<div className="marketplace_container">
			<MarketplaceHeader updateStateFromChild={this.updateStateFromChild} chosenMenu={this.state.chosenMenu} showOptions={false}></MarketplaceHeader>
			<div className="marketplace_main login_marketplace">
				<LoginContent updateStateFromChild={this.updateStateFromChild} history={this.props.history}></LoginContent>
			</div>
			<SupportContainer supportPageName={this.state.supportPageName} supportPageApi={this.state.supportPageApi} userTypeFaqs={this.state.userTypeFaqs}></SupportContainer>
			{ this.state.showLoader && <MainLoader></MainLoader> }
		</div>
    );
  }
}
export default LoginPage;
